import { NvSubNavModule } from './../../../shared/components/nv-sub-nav/nv-sub-nav.module';
import { PageBannerModule } from 'Src/ng2/shared/components/page-banner/page-banner.module';
import { MaintenanceModeModule } from './../../../shared/components/maintenance-mode/maintenance-mode.module';
import { NetworkLeftSideNavModule } from './../../network-left-side-nav/network-left-side-nav.module';
import { NetworkTabLayoutComponent } from './network-tab-layout.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [NetworkTabLayoutComponent],
  imports: [
    CommonModule,
    RouterModule,
    NetworkLeftSideNavModule,
    MaintenanceModeModule,
    PageBannerModule,
    NvSubNavModule,
  ],
  exports: [NetworkTabLayoutComponent],
  providers: [],
  schemas: [],
})
export class NetworkTabLayoutModule {}
